export default "__VITE_ASSET__BaRKDGIx__"